import React from 'react';
import DateField from '../../../../../Components/Form/components/DateField';
import DiagnosisSelectField from '../../../../../Components/Base/Diagnosis/DiagnosisSelectField';
import CheckboxField from '../../../../../Components/Form/components/CheckboxField';
import Text from '../../../../../Components/Base/Text/Text';
import styles from './CSSZSickLeaveCertificateFormPartD.module.scss';
import CSSZSickLeaveCertificateFormHeadline from './CSSZSickLeaveCertificateFormHeadline';
import useSickLeaveDateBounds from '../../Hooks/useSickLeaveDateBounds';

const CSSZSickLeaveCertificateFormPartD: React.FC = () => {
	const { issueDateMin, issueDateMax, dateFromMin, dateFromMax } =
		useSickLeaveDateBounds();

	return (
		<>
			<CSSZSickLeaveCertificateFormHeadline title='component.CSSZSickLeaveCertificateFormPartD.title' />
			<div className='row'>
				<div className='col-6'>
					<DateField
						name='issueDate'
						label='component.CSSZSickLeaveCertificateFormPartD.issueDate'
						isWrapped
						isRequired
						minDate={issueDateMin}
						maxDate={issueDateMax}
					/>
					<DateField
						name='dateFrom'
						label='component.CSSZSickLeaveCertificateFormPartD.incapacityStartDate'
						isWrapped
						isRequired
						minDate={dateFromMin}
						maxDate={dateFromMax}
					/>
					<DiagnosisSelectField
						name='diagnosis'
						label='component.CSSZSickLeaveCertificateFormPartD.diagnosis'
						isWrapped
						isRequired
					/>
				</div>
				<div className='col-6'>
					<CheckboxField
						name='injury'
						tx='component.CSSZSickLeaveCertificateFormPartD.injury'
						isWrapped
					/>
					<Text
						tx='component.CSSZSickLeaveCertificateFormPartD.insuredPersonStates'
						className={styles.label}
					/>
					<CheckboxField
						name='workAccident'
						tx='component.CSSZSickLeaveCertificateFormPartD.workAccident'
						isWrapped
					/>
					<CheckboxField
						name='injuryByOther'
						tx='component.CSSZSickLeaveCertificateFormPartD.injuryByOther'
						isWrapped
					/>
					<CheckboxField
						name='alcoholOrDrugs'
						tx='component.CSSZSickLeaveCertificateFormPartD.alcoholOrDrugs'
						isWrapped
					/>
				</div>
			</div>
		</>
	);
};

export default CSSZSickLeaveCertificateFormPartD;
